export default __webpack_public_path__ + "static/media/hygienic-1.72119bc2.png";